module.exports = __webpack_public_path__ + "media/images/icons/outlined/edit-9ebf2de0c9845e70615fe619abe65ad2.svg";